import React from 'react';
import ParagraphProps from '@src/components/Paragraph/paragraph-props';

interface VideoModel {
  name: 'Youtube' | 'Vimeo';
  provider: 'YouTube' | 'Vimeo';
  url: string;
  id: string;
}

const videoSrc = (model: VideoModel): string | null => {
  switch (model.provider) {
    case 'Vimeo':
      return `https://player.vimeo.com/video/${model.id}?dnt=1`;

    case 'YouTube':
      return `https://www.youtube-nocookie.com/embed/${model.id}`;

    default:
      console.warn(`Unmapped provider ${model.provider}`);
      return null;
  }
};

const VideoParagraph = (props: ParagraphProps) => {
  const model = props.paragraph.data as VideoModel;
  const src = videoSrc(model);
  if (!src) {
    return null;
  }
  return (
    <section className="paragraph video-paragraph">
      <iframe allowFullScreen frameBorder="0" src={src} title={model.name} />
    </section>
  );
};

export default VideoParagraph;
